module.exports = __webpack_public_path__ + "static/media/zu.dd5a9430.png";